// extracted by mini-css-extract-plugin
module.exports = {"info":"info___QGacU","tag":"tag___17QeW"};